<template>
    <div class="personalMain">
        <p class="current">当前位置：<span>我的订单</span><i class="el-icon-arrow-right"></i>
      <span>{{ status == 'all'?'全部订单': status == 'notpay' ? '待付款': status == 'pay'?'待发货' : status == 'express'?'待收货': status == 'confirm'?'已完成':''}}</span></p>
      <div class="personal-box">
        <Menu></Menu>
        <div class="MainInfo">
          <div class="orderButton" style="margin-bottom: 40px;">
              <el-button :type="status == 'all'? 'primary': ''" @click="status = 'all'">全部</el-button>
              <el-button :type="status == 'notpay'? 'primary': ''" @click="status = 'notpay'">待付款</el-button>
              <el-button :type="status == 'pay'? 'primary': ''" @click="status = 'pay'">待发货</el-button>
              <el-button :type="status == 'express'? 'primary': ''" @click="status = 'express'">待收货</el-button>
              <el-button :type="status == 'confirm'? 'primary': ''" @click="status = 'confirm'">已完成</el-button>
          </div>
          <div v-show="cartList == ''" class="cartNull">
            <p>亲，未找到记录~</p>
            
          </div>
         
          <div class="mySin-context"  v-show="cartList != ''">
           
            <div v-for="item,index in cartList" :key='index' class="personal-Item" >
              <div class="Item-Title">
                <p>订单：{{ item.order_no }}</p>
              </div>
              <div class="orderInfo" >
                <div class="Item-left">
                    <div v-if="item.order_items != ''" 
                    :style="'background-image:url('+item.order_items[0].firstFile.FileUrl+');cursor: pointer;background-size: cover;background-repeat: no-repeat;background-position: center;width: 100px;height: 72px;'"
                    @click="getOrderItem(item)"
                    ></div>
                    <div v-else style="width: 100px;height: 72px;border: 1px solid #f2f2f2;cursor: pointer;" @click="getOrderItem(item)"></div>
                    
                    <div class="left-font">
                      <p> {{item.order_items != ''?item.order_items[0].product_name: ''}}</p>
                      <span>{{item.order_items != ''?item.order_items[0].price: ''}}
                        <span v-if="item.order_items!= '' && item.order_items[0].amount > 0" style="font-size: 14px;color: #666666;">X
                          {{item.order_items != ''?item.order_items[0].amount: ''}}</span> </span>
                        <!-- <p>{{item.order_items != ''?item.order_items[0].product_name: ''}}</p>
                        <span>{{item.order_items != ''?item.order_items[0].price: ''}}<span v-if=" item.order_items[0].amount > 0" style="font-size: 14px;color: #666666;">X{{item.order_items != ''?item.order_items[0].amount: ''}}</span> </span> -->
                    </div>
                </div>
                <div class="orderStatus">
                    <el-button round @click="infoSelf(item)">详情</el-button>
                    <el-button round v-if="item.ispay=='0'"  @click="payStatus(item)">收款</el-button>
                    <el-button v-if="item.isexpress=='1'" round>已发货</el-button>
                    <el-button v-else @click="orderConfirm(item.order_no)" round>发货</el-button>
                    
                   
                </div>
                   

              </div>
            </div>
            <div style="text-align: right;">
              <el-pagination
                  :hide-on-single-page="hideOnSinglePage"
                  :page-size="20"
                  :pager-count="widthNew?11:5"
                  @current-change="handleCurrentChange"
                  layout="prev, pager, next"
                  :total="total">
                </el-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Menu from '../personal/index.vue'
  export default {
    data(){
      return{
        num: 0,
        cartList: [],
        status: '',
        widthNew: false,
        total: 0,
        hideOnSinglePage: true,
      }
    },
    components:{
        Menu
    },
    watch: {
      status(newVal,oldVal){
        let data = {
            pageNum: '1',
            pageSize: '20',
            vsstatus: newVal,
            order_cate: 'product',
        }
        this.listSelf(data)
      }
    },
    methods: {
      getOrderItem(item){
        let i = item.order_items.length
        if(i > 0){
          const { href } = this.$router.resolve({
            path: "/enableInfo",
            query: {
                id: item.order_items[0].product_id,
            }
          });
          window.open(href, '_blank');
        }
        
        
      },
  
      listSelf(data){
        this.$store.dispatch('personal/listSelfB',data)
          .then(res => {
            if(res.ok){
              this.cartList = []
              let list = res.data.items

              list.forEach(item => {
                if(item.status != '已取消'){
                  this.cartList.push(item)
                }
              });
              this.total = res.data.total

              if(this.total <= 20){
                  this.hideOnSinglePage = true
              }else{
                  this.hideOnSinglePage = false
              }
              
            }
          })
      },
      infoSelf(item){
       
        const { href } = this.$router.resolve({
            path: '/infoSelf',
            query: {
            order_no: item.order_no,
            invoice_id: item.invoice_id,
            invoice_address_id: item.invoice_address_id
            }
        })
        window.open(href, '_blank')
        
        
      },
      payStatus(item){
        this.$confirm('确定收款吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    ispay: 1,
                    order_no: item.order_no
                }
                this.$store.dispatch('personal/changePayStatus',data)
                    .then(res => {
                        if (res.ok) {
                            this.$notify({
                                title: '提示',
                                message: '收款成功',
                                type: 'success'
                            })

                            let data = {
                                pageNum: '1',
                                pageSize: '20',
                                vsstatus: this.status,
                                order_cate: 'product',
                            }
                            this.listSelf(data)
                        }
                    })
            
            }).catch(() => {
                    
            });
      },
      handleCurrentChange(val){
          let data = {
            pageNum: val,
            pageSize: '20',
            vsstatus: this.status,
            order_cate: 'product',
          }
          this.listSelf(data)
          
      },
      applyAfterSales(val){
        const { href } = this.$router.resolve({
          path: '/applyAfterSales',
          query: {
            order_no: val
          }
        })
        window.open(href, '_blank')
      },
      remark(item){
        console.log(item);
        if(item.order_items != ''){
          const { href } = this.$router.resolve({
            path: '/remark',
            query: {
              order_no: item.order_no,
              product_id: item.order_items[0].product_id,
              item_id: item.order_items[0].id,
            }
          })
          window.open(href, '_blank')
        }else{
          const { href } = this.$router.resolve({
            path: '/remark',
            query: {
              order_no: item.order_no,
              product_id: '',
              item_id: '',
            }
          })
          window.open(href, '_blank')
        }
       
        
      },
      unDef(val){
        this.$confirm('确定要取消吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            order_no: val
          }
          this.$store.dispatch('personal/cancelSelf',data)
            .then(res => {
              if(res.ok){
                this.$notify({
                  title: '提示',
                  message: '取消成功',
                  type: 'success'
                })
                let data = {
                  pageNum: '1',
                  pageSize: '20',
                  vsstatus: this.status,
                  order_cate: 'product',
                }
                this.listSelf(data)
              }
            })
         
        }).catch(() => {
                
        });
      },
      orderConfirm(val){
        this.$router.push({
            path: '/OrdersExpressEdit',
            query: {
                orderOn: val
            }
        })
      },
      quick(item){
        if(item.pay_cate == 'offline'){ //线下支付
          let price = 0
          if(item.order_items != ''){
            price = item.order_items[0].price * item.order_items[0].amount
          }
          this.$router.push({
            path: '/offline',
            query:{
              orderNo: item.order_no,
              total_price: price
            }
            
          })
        }else{
          const { href } = this.$router.resolve({
            path: '/checkoutQuick',
            query: {
                order: item.order_no
            }
          })
          window.open(href, '_blank')
        }
       
      }
    },
    mounted(){
        this.status = this.$route.query.vsstatus
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
    },
    created(){

    }
  }
  </script>
  
  
  <style scoped>
  @import url(../../css/personal.css);

  .personal-Item{
    margin-top: 20px;
    padding-bottom: 20px;
    padding-left: 10px;
    border-bottom: 0.5px solid #f2f2f2;
    font-size: 20px;
  }
  
  .Item-Title{
    font-size: 18px;
    margin-bottom: 20px;
    
  }

  .Item-left{
    width: 70%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .Item-left .left-font{
    margin-left: 20px;
    font-size: 19px;
  }
  .Item-left .left-font p{
    margin-bottom: 15px;
  }
  .Item-left .left-font span{
    color: #ff2f4f;
    font-weight: 600;
  }
  
  .Item-right .el-input-number{
    width: 140px;
  }
  
  .cartNull{
    font-size: 20px;
    margin-top: 120px;
    line-height: 50px;
    color: #666666;
    text-align: center;
  }
  @media screen and (min-width: 541px){
    .orderInfo{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  @media screen and (max-width: 540px){
    .Item-left{
      margin-bottom: 20px
    }
    .orderStatus{
      text-align: right
    }
  }
  @import url(../../css/personal540.css);
  </style>